import { useEffect, useState, useContext } from "react";
import LabCenterComponent from "../../components/LabCenterComponent";
import useAxios from "../../common/hook/useAxios";
import { toast } from "react-toastify";
import { AuthContext } from "../../context/AuthContext";
import { firstTableDayParam, formatDate, search } from "../../constant";

const LabCenter = () => {
  const { request } = useAxios();
  // const [selectAllPatients, setSelectAllPatients] = useState(false);
  // const [patients, setPatients] = useState([]);
  const [firstData, setFirstData] = useState([]);
  const [secondData, setSecondData] = useState([]);
  const [thirdData, setThirdData] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [isResult, setIsResult] = useState(false);
  const { user } = useContext(AuthContext);
  const [selectedSearch, setSelectedSearch] = useState(search[0]?.value);
  const [selectedPatientRows, setSelectedPatientRows] = useState({});
  const [selectedDOS, setSelectedDOS] = useState(null);
  const [filterType, setFilterType] = useState(null); // "sent", "received", "notReceived"

  const handleFilterClick = (dos, type) => {
    setSelectedDOS(dos);
    setFilterType(type);
  };
  useEffect(() => {
    setSelectedSearch(search[0]?.value);
  }, [selectedSearch]);

  const resetResultOnly = () => {
    const FromDate = formatDate(fromDate);
    const ToDate = formatDate(toDate);
    // console.log(selectedSearch);
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabReconcillation?sInputJSON={"PracticeId":"${user?.PracticeID}","FromDate":"${FromDate}","ToDate":"${ToDate}","SearchBy":${selectedSearch},"IsResultOnly":false}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        // console.log(res, "res");
        setThirdData(res);
      })
      .catch(() => {
        toast.error("Error occurred while in lab center", {
          autoClose: 3000,
        });
      });
  };

  useEffect(() => {
    if (user?.PracticeID) {
      handleData();
    }
  }, [user]);

  const handleData = async () => {
    const FromDate = formatDate(fromDate);
    const ToDate = formatDate(toDate);
    await getFirstTableData(FromDate);
    await getSecondTableData(FromDate, ToDate);
    await getThirdTableData(FromDate, ToDate);
  };

  const getFirstTableData = (FromDate) => {
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabResults/GetProcessedFileCount?sInputJSON={objLab:{'Days':${firstTableDayParam},'PracticeID':'${user?.PracticeID}','FromDOS':"${FromDate}"}}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setSecondData(res);
      })
      .catch((err) => {
        console.log(err);
        toast.error("Error occurred while fetching labs", {
          autoClose: 3000,
        });
      });
  };

  const getSecondTableData = (FromDate, ToDate) => {
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabReconcillation?sInputJSON={"PracticeId":"${user?.PracticeID}","FromDate":"${FromDate}","ToDate":"${ToDate}","SearchBy":${selectedSearch},"IsResultOnly":${isResult}}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setThirdData(res);
      })
      .catch(() => {
        toast.error("Error occurred while fetching labs", {
          autoClose: 3000,
        });
      });
  };

  const getThirdTableData = (FromDate, ToDate) => {
    const url = `${process.env.REACT_APP_TEMPLATES_URL}/LabReconcillation/GetPracticeReconDataCount?sInputJSON={"PracticeId":"${user?.PracticeID}","FromDate":"${FromDate}","ToDate":"${ToDate}"}`;
    request(url, {
      method: "GET",
    })
      .then((res) => {
        setFirstData(res);
        setFilterType(null)
        setSelectedDOS(null)
      })
      .catch(() => {
        toast.error("Error occurred while fetching labs", {
          autoClose: 3000,
        });
      });
  };
  return (
    <div>
      <LabCenterComponent
        firstData={firstData}
        toast={toast}
        secondData={secondData}
        thirdData={thirdData}
        setFromDate={setFromDate}
        setToDate={setToDate}
        fromDate={fromDate}
        toDate={toDate}
        handleData={handleData}
        isResult={isResult}
        setIsResult={setIsResult}
        selectedSearch={selectedSearch}
        setSelectedSearch={setSelectedSearch}
        resetResultOnly={resetResultOnly}
        selectedDOS={selectedDOS}
        filterType={filterType}
        handleFilterClick={handleFilterClick}
        setThirdData={setThirdData}
      />
    </div>
  );
};

export default LabCenter;
